import L from 'leaflet';

const BASEMAP_ESRI_URL = 'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas';
const BASEMAP_TILES_URL = `${BASEMAP_ESRI_URL}/World_Dark_Gray_Base/MapServer/tile/{z}/{y}/{x}`;
const BASEMAP_LABELS_URL = `${BASEMAP_ESRI_URL}/World_Dark_Gray_Reference/MapServer/tile/{z}/{y}/{x}`;

// Os tiles da Esri só existem até o zoom 16; acima disso o Leaflet amplia o último nível
const OPCOES_TILES = { maxZoom: 19, maxNativeZoom: 16 };

/** Adiciona o mapa base escuro (fundo + rótulos) ao mapa Leaflet */
export function addBasemap(map) {
  L.tileLayer(BASEMAP_TILES_URL, {
    ...OPCOES_TILES,
    attribution: 'Tiles &copy; <a href="https://www.esri.com">Esri</a>',
  }).addTo(map);
  L.tileLayer(BASEMAP_LABELS_URL, OPCOES_TILES).addTo(map);
}
